module.exports = __webpack_public_path__ + "static/media/lo_bosrand.e424b336.svg";